// extracted by mini-css-extract-plugin
export default {"next":"index_next__GBz0l","head":"index_head__gj8W2"};